module.exports = "/_next/static/images/AppGallery-5cc0279cb0d343fdb0d803d56bbdf703.svg";